var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"GImage",attrs:{"src":_vm._f("isWebp")(_vm.src,_vm.src),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }